// extracted by mini-css-extract-plugin
export default {"container":"x4TiW","title":"xhs_9","lh-22":"C1bx2","lh22":"C1bx2","skeleton-placeholder-pulse":"aIhkV","skeletonPlaceholderPulse":"aIhkV"};